/**
 * Resolved API base for axios clients. Browser uses same-origin `/api/proxy` (dev Next route or nginx in prod).
 * Server/build uses `NEXT_PUBLIC_API_URL` when set. Never put secrets in env vars prefixed with `NEXT_PUBLIC_`.
 */
export function getApiBaseUrl(): string {
  if (typeof window !== 'undefined') {
    return '/api/proxy';
  }
  return process.env.NEXT_PUBLIC_API_URL || '/api/proxy';
}
